(() => {
  if (window.__forceYampiCheckoutLoaded) return;
  window.__forceYampiCheckoutLoaded = true;

  const YAMPI_BUTTON_SELECTOR = '.js-yampi-checkout';
  const NATIVE_CHECKOUT_SELECTOR = 'button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]';

  // Timeout por request (ms). Se a API da Dooki/Yampi não responder nesse
  // prazo, cancelamos e caímos no fallback em vez de travar o botão.
  const FETCH_TIMEOUT_MS = 6000;
  const MAX_RETRIES = 1; // 1 retry além da tentativa original

  const getShopDomain = () => {
    if (window.Shopify && window.Shopify.shop) {
      return window.Shopify.shop;
    }
    return window.location.host;
  };

  const disableNativeCheckoutButtons = () => {
    const nativeButtons = document.querySelectorAll(NATIVE_CHECKOUT_SELECTOR);
    nativeButtons.forEach((button) => {
      if (button.classList.contains('js-yampi-checkout')) return;
      button.classList.add('js-yampi-checkout');
      button.classList.add('js-transparent-checkout-yampi-cart');
      button.classList.add('js-transparent-checkout-cart');
      button.setAttribute('data-checkout-provider', 'yampi');
      if (button.tagName === 'A') {
        button.setAttribute('href', '/cart');
        return;
      }
      button.setAttribute('type', 'button');
      button.removeAttribute('name');
      button.removeAttribute('form');
    });
  };

  // fetch com timeout via AbortController
  const fetchWithTimeout = async (url, options = {}, timeoutMs = FETCH_TIMEOUT_MS) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    try {
      const response = await fetch(url, { ...options, signal: controller.signal });
      return response;
    } finally {
      clearTimeout(timer);
    }
  };

  const getCartPayload = async () => {
    const response = await fetchWithTimeout('/cart.json', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    if (!response.ok) {
      console.error('[Yampi] Erro ao buscar /cart.json', response.status);
      return null;
    }
    return await response.json();
  };

  const extractCheckoutUrl = (payload) => {
    if (!payload) return null;
    return (
      payload.checkout_direct_url ||
      payload.checkout_url ||
      payload.url ||
      payload.redirect_url ||
      payload.data?.checkout_direct_url ||
      payload.data?.checkout_url ||
      payload.data?.url ||
      payload.data?.redirect_url ||
      null
    );
  };

  const requestYampiCheckoutUrl = async (cartPayload) => {
    const response = await fetchWithTimeout('https://api.dooki.com.br/v2/public/shopify/cart', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        shop: getShopDomain(),
        cart_payload: cartPayload
      })
    });
    let payload = null;
    try {
      payload = await response.json();
    } catch (error) {
      console.error('[Yampi] Resposta da API não é JSON', error);
    }
    if (!response.ok) {
      console.error('[Yampi] Erro na API Dooki/Yampi', response.status, payload);
      return null;
    }
    return extractCheckoutUrl(payload);
  };

  // cache simples pra não bater 2x na API se o usuário clicar rápido de novo
  let cachedCheckoutPromise = null;

  const getYampiCheckoutUrl = () => {
    if (cachedCheckoutPromise) return cachedCheckoutPromise;

    cachedCheckoutPromise = (async () => {
      const cartPayload = await getCartPayload();
      if (!cartPayload || !cartPayload.items || !cartPayload.items.length) {
        console.error('[Yampi] Carrinho vazio ou inválido', cartPayload);
        return null;
      }

      // Tenta a chamada principal + 1 retry se der timeout/erro de rede
      for (let attempt = 0; attempt <= MAX_RETRIES; attempt++) {
        try {
          const url = await requestYampiCheckoutUrl(cartPayload);
          if (url) return url;
        } catch (error) {
          const isAbort = error?.name === 'AbortError';
          console.error(
            isAbort
              ? `[Yampi] Timeout (${FETCH_TIMEOUT_MS}ms) na tentativa ${attempt + 1}`
              : `[Yampi] Erro de rede na tentativa ${attempt + 1}`,
            error
          );
        }
      }
      return null;
    })();

    // limpa o cache depois que resolver (sucesso ou erro), pra não travar cliques futuros com dado velho
    cachedCheckoutPromise.finally(() => {
      setTimeout(() => { cachedCheckoutPromise = null; }, 2000);
    });

    return cachedCheckoutPromise;
  };

  const withYampiUtms = (url) => {
    if (!url) return url;
    if (typeof window.ymp_getUrlWithUtms === 'function') {
      try {
        return window.ymp_getUrlWithUtms(url);
      } catch (error) {
        return url;
      }
    }
    return url;
  };

  const setButtonLoading = (button, loading) => {
    if (!button) return;
    if (loading) {
      // guarda o conteúdo original só na primeira vez
      if (button.dataset.originalHtml === undefined) {
        button.dataset.originalHtml = button.innerHTML;
      }
      button.dataset.loading = 'true';
      button.setAttribute('aria-busy', 'true');
      button.classList.add('is-loading');
      button.innerHTML =
        '<span class="yampi-spinner" aria-hidden="true"></span><span class="yampi-loading-text">Carregando...</span>';
    } else {
      button.dataset.loading = 'false';
      button.removeAttribute('aria-busy');
      button.classList.remove('is-loading');
      if (button.dataset.originalHtml !== undefined) {
        button.innerHTML = button.dataset.originalHtml;
      }
    }
  };

  // Dispara a função/botão nativo da Yampi só para efeitos colaterais
  // (tracking, pixel, etc) — NÃO bloqueia mais a navegação esperando isso.
  const fireYampiNativeSideEffects = () => {
    if (typeof window.yampiClick === 'function') {
      try {
        window.yampiClick();
        return;
      } catch (error) {
        console.error('[Yampi] Erro ao executar window.yampiClick()', error);
      }
    }
    const injectedButton = document.querySelector(
      '.ymp_check_mainBtn.ymp_elem_mainBtn, .ymp_check_mainBtn, .cartX_check_mainBtn'
    );
    if (injectedButton && !(injectedButton.href && !injectedButton.href.includes('/checkout'))) {
      try { injectedButton.click(); } catch (error) { /* silencioso, é só side-effect */ }
    }
  };

  const redirectToYampi = async (button) => {
    if (!button) return;
    if (button.getAttribute('aria-disabled') === 'true') return;
    if (button.dataset.loading === 'true') return;

    setButtonLoading(button, true);

    // dispara efeitos colaterais nativos SEM esperar
    fireYampiNativeSideEffects();

    try {
      const checkoutUrl = await getYampiCheckoutUrl();
      if (checkoutUrl) {
        window.location.href = withYampiUtms(checkoutUrl);
        return;
      }
      // Fallback: se a Yampi falhou/travou (timeout, erro, etc), manda
      // pro checkout nativo do Shopify em vez de deixar o cliente parado.
      console.warn('[Yampi] Falha ao obter URL de checkout — usando fallback nativo /checkout');
      window.location.href = '/checkout';
    } catch (error) {
      console.error('[Yampi] Erro geral ao abrir checkout', error);
      window.location.href = '/checkout';
    } finally {
      setButtonLoading(button, false);
    }
  };

  // ===== Delegação de evento em `document`: funciona mesmo que o botão
  // seja renderizado depois via AJAX (drawer do carrinho), porque o
  // listener já está anexado desde o load inicial da página. =====
  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest(
        YAMPI_BUTTON_SELECTOR + ', ' + NATIVE_CHECKOUT_SELECTOR
      );
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      redirectToYampi(button);
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const submitter = event.submitter;
      if (!submitter) return;
      const isCheckoutSubmit =
        submitter.name === 'checkout' ||
        submitter.id === 'checkout' ||
        submitter.classList.contains('js-yampi-checkout');
      if (!isCheckoutSubmit) return;
      event.preventDefault();
      event.stopPropagation();
      redirectToYampi(submitter);
    },
    true
  );

  disableNativeCheckoutButtons();

  // Observer mais enxuto: só reage quando nós relevantes são adicionados,
  // e usa debounce pra não rodar em cada micro-mutação da página.
  // Isso também cobre o caso do botão nativo aparecer via drawer AJAX,
  // já que esse script roda uma única vez no load da página.
  let debounceId;
  const debouncedDisable = () => {
    clearTimeout(debounceId);
    debounceId = setTimeout(disableNativeCheckoutButtons, 100);
  };

  const observer = new MutationObserver((mutations) => {
    const relevant = mutations.some((m) =>
      [...m.addedNodes].some((n) =>
        n.nodeType === 1 &&
        (n.matches?.(NATIVE_CHECKOUT_SELECTOR) || n.querySelector?.(NATIVE_CHECKOUT_SELECTOR))
      )
    );
    if (relevant) debouncedDisable();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();